
/**
 *	settings:
 *	Speichern der Users-Einstellung in der lokalen Umgebung.
 *
 * 	chrome.storage 		=>	Storage für Chrome-Plugins
 * 	localStorage		=>	Storage für Browser-Anwendungen
 *
 */

/**
 *	-----------------------------------------------------------
 *	State: Variablen
 */
export const state = {
	presets: {}
}

/**
 *	-----------------------------------------------------------
 *	Mutations sind immer synchon! Aufruf aus einem Component:
 *	this.$store.commit('settings/MODIFY', {presets:'...'});
 *
 */
export const mutations = {

	/**
	 *	Überschreiben von Voreinstellungen.
	 *	this.$store.commit('settings/MODIFY', {presets:'...'});
	 */
	MODIFY (state, overrideSettings = {}) {
		this.state.settings = Object.assign(state, overrideSettings)
	},

}

/**
 *	------------------------------------------------------------
 *	Actions können asynchon sein. Aufruf aus einem Component:
 *	this.$store.dispatch('SAVE', {presets:'...'});
 *
 */
export const actions = {

	/**
	 *	Voreinstellungen aus der localStorage laden.
	 *	Wird in der main.js bei Initialisierung aufgerufen.
	 *	this.$store.dispatch('LOAD_SETTINGS').then(() => {...});
	 *
	 */
	LOAD () {
		return new Promise((resolve, reject) => {
			if ( window.chrome && chrome.storage ) {
				chrome.storage.sync.get(['settings'], (data) => {
					this.state.settings = Object.assign({}, this.state.settings, data.settings)
					resolve( this.state )
				})
			} else if (localStorage) {
				var data = localStorage.getItem('settings')
				if (!data || data.substr(0, 1) != '{') data = '{}'
				data = JSON.parse(data)
				this.state.settings = Object.assign({}, this.state.settings, data)

				resolve( this.state )
			} else {
				console.log('No LocalStorage available')
				reject()
			}
		})
	},

	/**
 	 *	Voreinstellungen in der localStorage speichern.
	 *	Wird nach Klick auf "Speichern" in der Settings.vue aufgerufen.
	 *
	 */
	SAVE ({ commit }) {
		return new Promise((resolve, reject) => {

			if (window.chrome && chrome.storage) {
				chrome.storage.sync.set({ settings: this.state.settings }, () => {
					resolve()
				})
				this.dispatch('settings/LOAD')
			} else if (localStorage) {
				localStorage.setItem('settings', JSON.stringify(this.state.settings))
				this.dispatch('settings/LOAD')
				resolve()
			} else {
				console.log('No LocalStorage available')
				reject()
			}
		})
	},

	/**
	 *	Voreinstellung zurücksetzen.
	 *	this.$store.commit('RESET ');
	 *
	 */
	RESET ({ state }) {
		if (window.chrome && chrome.storage) {
			chrome.storage.sync.clear()
		} else if (localStorage) {
			localStorage.setItem('settings', null)
		}
		this.commit('settings/MODIFY', { presets:{} })
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js